export const updateNotifierArabic = {
  updateFoundTitle: 'هناك نسخة أحدث من {{appName}}',
  updateFoundDescription: 'قم بالتحديث لتصلك اخر نسخة',
  refreshButtonText: 'تحديث',
};
